module.exports = __webpack_public_path__ + "bg.svg?42d2146c9924d0aa0e491ba75299cff9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bg.svg
// module id = 1197
// module chunks = 27